import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SOURCES = ["Lead Gen Form", "Walk-in", "Instagram", "WhatsApp"];
export const CHANNELS = [["WHATSAPP", "WhatsApp"], ["CALL", "Call"], ["EMAIL", "Email"]];
export const TIMELINES = [["NOW", "Ready To Order Now"], ["2_WEEKS", "Within 2 Weeks"], ["1_MONTH", "Within 1 Month"], ["3_MONTHS", "Within 3 Months"], ["3_MONTHS_PLUS", "3 Months +"]];
export const optLabel = (opts, v) => (opts.find(([k]) => k === v) || [])[1] || "—";

export function ChoiceSelect({ value, onChange, opts, testid }) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Select" /></SelectTrigger>
      <SelectContent>{opts.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export function LeadExtraFields({ f, setF, prefix }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <>
      <div className="col-span-2 space-y-1.5"><Label>Use of the PC</Label><Input value={f.useCase} onChange={set("useCase")} data-testid={`${prefix}-usecase-input`} /></div>
      <div className="space-y-1.5"><Label>Preferred contact</Label><ChoiceSelect value={f.contactChannel} onChange={(v) => setF({ ...f, contactChannel: v })} opts={CHANNELS} testid={`${prefix}-channel-select`} /></div>
      <div className="space-y-1.5"><Label>Delivery timeline</Label><ChoiceSelect value={f.deliveryTimeline} onChange={(v) => setF({ ...f, deliveryTimeline: v })} opts={TIMELINES} testid={`${prefix}-timeline-select`} /></div>
      <div className="space-y-1.5"><Label>Company name</Label><Input value={f.companyName} onChange={set("companyName")} data-testid={`${prefix}-company-input`} /></div>
      <div className="space-y-1.5"><Label>Position</Label><Input value={f.position} onChange={set("position")} data-testid={`${prefix}-position-input`} /></div>
    </>
  );
}

export function LeadFields({ onSubmit, showSource = true, submitText = "Submit", busy }) {
  const [f, setF] = useState({ clientName: "", clientEmail: "", clientPhone: "", clientCity: "", budget: "", source: "Lead Gen Form", requirements: "", useCase: "", contactChannel: "", deliveryTimeline: "", companyName: "", position: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <form className="grid grid-cols-2 gap-4" onSubmit={(e) => { e.preventDefault(); onSubmit({ ...f, budget: +f.budget || 0 }); }} data-testid="lead-form">
      <div className="col-span-2 space-y-1.5"><Label>Full name *</Label><Input required value={f.clientName} onChange={set("clientName")} data-testid="lead-name-input" /></div>
      <div className="space-y-1.5"><Label>Phone *</Label><Input required value={f.clientPhone} onChange={set("clientPhone")} placeholder="+91" data-testid="lead-phone-input" /></div>
      <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={f.clientEmail} onChange={set("clientEmail")} data-testid="lead-email-input" /></div>
      <div className="space-y-1.5"><Label>City</Label><Input value={f.clientCity} onChange={set("clientCity")} data-testid="lead-city-input" /></div>
      <div className="space-y-1.5"><Label>Budget (₹)</Label><Input type="number" value={f.budget} onChange={set("budget")} data-testid="lead-budget-input" /></div>
      {showSource && (
        <div className="col-span-2 space-y-1.5"><Label>Source</Label>
          <Select value={f.source} onValueChange={(v) => setF({ ...f, source: v })}>
            <SelectTrigger data-testid="lead-source-select"><SelectValue /></SelectTrigger>
            <SelectContent>{SOURCES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select></div>
      )}
      <LeadExtraFields f={f} setF={setF} prefix="lead" />
      <div className="col-span-2 space-y-1.5"><Label>Notes / requests</Label>
        <Textarea rows={3} value={f.requirements} onChange={set("requirements")} placeholder="Games / workloads, resolution, aesthetic preferences" data-testid="lead-requirements-input" /></div>
      <Button type="submit" className="col-span-2" disabled={busy} data-testid="lead-submit-button">{submitText}</Button>
    </form>
  );
}
